export const translations = {
  en: {
    common: {
      brand: "REXX APP STORE",
      network: "Rexxpons Network",
      cognitiveSystem: "Cognitive Immediate Installation System",
      autonomous: "Autonomous • Rigorous • Secure",
      loading: "Loading...",
      cancel: "Cancel",
      save: "Save",
      close: "Close",
      done: "Done",
      price: "Price",
      seller: "Seller",
      category: "Category",
      description: "Description",
      version: "Version",
      free: "FREE",
    },
    nav: {
      developer: "Developer",
      market: "App Market",
      seller: "Seller Panel",
      modules: "Modules",
      logout: "Log out",
    },
    auth: {
      access: "Access Terminal",
      registerNode: "Register Node",
      accessSub: "Authenticate to enter the Rexx Network.",
      registerSub: "Create your Rexxpons Network identity.",
      name: "Name",
      email: "Email",
      password: "Password",
      role: "Role",
      developer: "developer",
      seller: "seller",
      buyer: "buyer",
      authenticate: "Authenticate",
      register: "Register",
      processing: "Processing...",
      toRegister: "No node yet? Register →",
      toLogin: "Already registered? Sign in →",
      demo: "DEMO",
      uploadVerifyPublish: "Upload. Verify. Publish.",
      heroDesc: "The Rexx Cognitive Engine autonomously runs technical, cognitive and governance verification on every APK before it reaches the network.",
      technical: "Technical",
      cognitive: "Cognitive",
      governance: "Governance",
    },
    dashboard: {
      tag: "DEVELOPER DASHBOARD",
      title: "Cognitive Console",
      uploadApp: "Upload Application",
      totalApps: "Total Apps",
      verified: "Verified",
      notVerified: "Not Verified",
      published: "Published",
      avgRisk: "Avg Risk",
      empty: "No applications yet. Upload your first APK to begin cognitive verification.",
      risk: "Risk",
      coherence: "Coherence",
      reputation: "Reputation",
      permissionMap: "Permission Map",
      liveOnMarket: "Live on Market",
      publish: "Publish",
      requestReg: "Request Regularization",
      regRequested: "Regularization Requested",
      delete: "Delete",
      appUpload: "Application Upload",
      uploadHint: "Upload your APK to start cognitive verification.",
      appName: "App Name",
      selectApk: "Click to select APK file",
      startVerification: "Start Cognitive Verification",
      uploading: "Uploading APK to secure storage…",
      resultTitle: "Verification Result",
      verifiedMsg: "Your application meets all cognitive requirements.",
      notVerifiedMsg: "This application did not pass the cognitive verification. No need to worry: it can be regularized at any time — no payment required.",
      doneManage: "Done — Manage on Dashboard",
      closeReg: "Close — Manage on Dashboard",
      publishTitle: "Publish to Rexx App Store",
      priceEuro: "Price (€) — set 0 for free download",
      appIcon: "App Icon",
      screenshots: "Screenshots (up to 8)",
      selectIcon: "Click to select an icon image",
      selectShots: "Click to select screenshots",
      detailedDesc: "Detailed Description",
      publishNow: "Publish Now",
    },
    scan: {
      title: "REXX COGNITIVE ENGINE — SCANNING",
      technical: "TECHNICAL VERIFICATION",
      cognitive: "COGNITIVE VERIFICATION",
      governance: "GOVERNANCE VERIFICATION",
    },
    market: {
      tag: "APP MARKET",
      title: "Buy, Sell & Request Applications",
      subtitle: "Every application is cognitively analysed by the Rexx Network before listing.",
      empty: "No applications listed yet. Publish an app from your dashboard.",
      buyNow: "Buy Now",
      request: "Request",
      contact: "Contact",
      download: "Free Download",
      yourListing: "This is your listing",
      noDescription: "No description provided.",
      details: "Details",
      screenshotsLabel: "Screenshots",
      contactTitle: "Contact Seller",
      contactBody1: "Reach out to",
      contactBody2: "regarding",
      contactNote: "Secure messaging is part of the upcoming Rexx Wallet identity binding. Use Request Purchase to notify the seller.",
      sendInstead: "Send Purchase Request Instead",
    },
    seller: {
      tag: "SELLER PANEL",
      title: "Manage Listings & Requests",
      buyerRequests: "Buyer Requests",
      pending: "pending",
      noRequests: "No purchase requests yet.",
      yourListings: "Your Listings",
      noListings: "No apps listed for sale. Publish an app from your dashboard.",
      approve: "Approve",
      reject: "Reject",
      editPrice: "Edit Price",
      remove: "Remove",
    },
    modules: {
      tag: "ADVANCED MODULES",
      title: "Rexx Network Extensions",
      subtitle: "These modules extend the Rexx App Store with wallet, payments, contracts and reputation. They are disabled by default and will activate as the network matures.",
      disabled: "Disabled",
      wallet: "Rexx Wallet",
      walletItems: ["Balance", "Transaction history", "Secure identity binding"],
      payment: "Payment Methods",
      paymentItems: ["Rexx Wallet", "Credit / Debit cards", "Crypto (optional)"],
      commission: "Commission System",
      commissionItems: ["Seller commission", "Platform fee", "Developer royalty"],
      contracts: "Digital Contracts",
      contractsItems: ["Smart agreements for purchases", "Automatic approval logs", "Buyer / Seller signatures"],
      rating: "Seller Rating System",
      ratingItems: ["Reliability score", "Delivery speed", "Cognitive compliance", "Buyer feedback"],
    },
    toast: {
      appDeleted: "Application deleted",
      priceUpdated: "Price updated",
      removed: "Removed from market",
      published: "{name} published to Rexx App Store",
      approved: "Purchase approved",
      rejected: "Request rejected",
      walletDisabled: "Rexx Wallet is disabled",
      walletDisabledDesc: "Instant checkout requires the Rexx Wallet module. Use Request Purchase or free download.",
      regDone: "Application marked Regularizable",
      nameApkRequired: "App name and APK file are required",
      uploadFailed: "Upload failed",
      failed: "Operation failed",
      requestSent: "Purchase Request Sent",
      requestSentDesc: "The seller will review your request. You will receive a confirmation soon.",
      downloadStarted: "Download started",
    },
  },

  it: {
    common: {
      brand: "REXX APP STORE",
      network: "Rete Rexxpons",
      cognitiveSystem: "Sistema di Installazione Cognitiva Immediata",
      autonomous: "Autonomo • Rigoroso • Sicuro",
      loading: "Caricamento...",
      cancel: "Annulla",
      save: "Salva",
      close: "Chiudi",
      done: "Fatto",
      price: "Prezzo",
      seller: "Venditore",
      category: "Categoria",
      description: "Descrizione",
      version: "Versione",
      free: "GRATIS",
    },
    nav: {
      developer: "Sviluppatore",
      market: "Mercato App",
      seller: "Pannello Venditore",
      modules: "Moduli",
      logout: "Esci",
    },
    auth: {
      access: "Terminale di Accesso",
      registerNode: "Registra Nodo",
      accessSub: "Autenticati per entrare nella Rete Rexx.",
      registerSub: "Crea la tua identità sulla Rete Rexxpons.",
      name: "Nome",
      email: "Email",
      password: "Password",
      role: "Ruolo",
      developer: "sviluppatore",
      seller: "venditore",
      buyer: "acquirente",
      authenticate: "Autenticati",
      register: "Registrati",
      processing: "Elaborazione...",
      toRegister: "Nessun nodo? Registrati →",
      toLogin: "Già registrato? Accedi →",
      demo: "DEMO",
      uploadVerifyPublish: "Carica. Verifica. Pubblica.",
      heroDesc: "Il Motore Cognitivo Rexx esegue autonomamente la verifica tecnica, cognitiva e di governance su ogni APK prima che raggiunga la rete.",
      technical: "Tecnica",
      cognitive: "Cognitiva",
      governance: "Governance",
    },
    dashboard: {
      tag: "CONSOLE SVILUPPATORE",
      title: "Console Cognitiva",
      uploadApp: "Carica Applicazione",
      totalApps: "App Totali",
      verified: "Verificate",
      notVerified: "Non Verificate",
      published: "Pubblicate",
      avgRisk: "Rischio Medio",
      empty: "Nessuna applicazione ancora. Carica il tuo primo APK per avviare la verifica cognitiva.",
      risk: "Rischio",
      coherence: "Coerenza",
      reputation: "Reputazione",
      permissionMap: "Mappa Permessi",
      liveOnMarket: "In vendita sul Mercato",
      publish: "Pubblica",
      requestReg: "Richiedi Regolarizzazione",
      regRequested: "Regolarizzazione Richiesta",
      delete: "Elimina",
      appUpload: "Caricamento Applicazione",
      uploadHint: "Carica il tuo APK per avviare la verifica cognitiva.",
      appName: "Nome App",
      selectApk: "Clicca per selezionare il file APK",
      startVerification: "Avvia Verifica Cognitiva",
      uploading: "Caricamento APK nello storage sicuro…",
      resultTitle: "Risultato Verifica",
      verifiedMsg: "La tua applicazione soddisfa tutti i requisiti cognitivi.",
      notVerifiedMsg: "Questa applicazione non ha superato la verifica cognitiva. Nessun problema: può essere regolarizzata in qualsiasi momento — nessun pagamento richiesto.",
      doneManage: "Fatto — Gestisci nella Console",
      closeReg: "Chiudi — Gestisci nella Console",
      publishTitle: "Pubblica sul Rexx App Store",
      priceEuro: "Prezzo (€) — imposta 0 per download gratuito",
      appIcon: "Icona App",
      screenshots: "Screenshot (fino a 8)",
      selectIcon: "Clicca per selezionare un'icona",
      selectShots: "Clicca per selezionare gli screenshot",
      detailedDesc: "Descrizione Dettagliata",
      publishNow: "Pubblica Ora",
    },
    scan: {
      title: "MOTORE COGNITIVO REXX — SCANSIONE",
      technical: "VERIFICA TECNICA",
      cognitive: "VERIFICA COGNITIVA",
      governance: "VERIFICA GOVERNANCE",
    },
    market: {
      tag: "MERCATO APP",
      title: "Compra, Vendi & Richiedi Applicazioni",
      subtitle: "Ogni applicazione viene analizzata cognitivamente dalla Rete Rexx prima della pubblicazione.",
      empty: "Nessuna applicazione pubblicata. Pubblica un'app dalla tua console.",
      buyNow: "Compra Ora",
      request: "Richiedi",
      contact: "Contatta",
      download: "Download Gratuito",
      yourListing: "Questo è il tuo annuncio",
      noDescription: "Nessuna descrizione fornita.",
      details: "Dettagli",
      screenshotsLabel: "Screenshot",
      contactTitle: "Contatta il Venditore",
      contactBody1: "Contatta",
      contactBody2: "riguardo",
      contactNote: "La messaggistica sicura fa parte del futuro binding identità Rexx Wallet. Usa Richiedi Acquisto per avvisare il venditore.",
      sendInstead: "Invia invece una Richiesta di Acquisto",
    },
    seller: {
      tag: "PANNELLO VENDITORE",
      title: "Gestisci Annunci & Richieste",
      buyerRequests: "Richieste Acquirenti",
      pending: "in attesa",
      noRequests: "Nessuna richiesta di acquisto ancora.",
      yourListings: "I Tuoi Annunci",
      noListings: "Nessuna app in vendita. Pubblica un'app dalla tua console.",
      approve: "Approva",
      reject: "Rifiuta",
      editPrice: "Modifica Prezzo",
      remove: "Rimuovi",
    },
    modules: {
      tag: "MODULI AVANZATI",
      title: "Estensioni della Rete Rexx",
      subtitle: "Questi moduli estendono il Rexx App Store con wallet, pagamenti, contratti e reputazione. Sono disabilitati di default e si attiveranno con la crescita della rete.",
      disabled: "Disabilitato",
      wallet: "Rexx Wallet",
      walletItems: ["Saldo", "Cronologia transazioni", "Binding identità sicuro"],
      payment: "Metodi di Pagamento",
      paymentItems: ["Rexx Wallet", "Carte di credito / debito", "Crypto (opzionale)"],
      commission: "Sistema Commissioni",
      commissionItems: ["Commissione venditore", "Fee di piattaforma", "Royalty sviluppatore"],
      contracts: "Contratti Digitali",
      contractsItems: ["Accordi smart per gli acquisti", "Log di approvazione automatici", "Firme Acquirente / Venditore"],
      rating: "Sistema di Valutazione Venditori",
      ratingItems: ["Punteggio affidabilità", "Velocità di consegna", "Conformità cognitiva", "Feedback acquirenti"],
    },
    toast: {
      appDeleted: "Applicazione eliminata",
      priceUpdated: "Prezzo aggiornato",
      removed: "Rimosso dal mercato",
      published: "{name} pubblicata sul Rexx App Store",
      approved: "Acquisto approvato",
      rejected: "Richiesta rifiutata",
      walletDisabled: "Rexx Wallet è disabilitato",
      walletDisabledDesc: "Il checkout immediato richiede il modulo Rexx Wallet. Usa Richiedi Acquisto o il download gratuito.",
      regDone: "Applicazione contrassegnata come Regolarizzabile",
      nameApkRequired: "Nome app e file APK sono obbligatori",
      uploadFailed: "Caricamento fallito",
      failed: "Operazione fallita",
      requestSent: "Richiesta di Acquisto Inviata",
      requestSentDesc: "Il venditore esaminerà la tua richiesta. Riceverai presto una conferma.",
      downloadStarted: "Download avviato",
    },
  },
};

export const CHECK_TR = {
  it: {
    "APK signature validation": "Validazione firma APK",
    "File integrity check": "Controllo integrità file",
    "Manifest & permissions analysis": "Analisi manifest e permessi",
    "Library & compatibility inspection": "Ispezione librerie e compatibilità",
    "Function/behavior coherence": "Coerenza funzioni/comportamento",
    "Risk signal detection": "Rilevamento segnali di rischio",
    "Behavioral pattern analysis": "Analisi pattern comportamentali",
    "Developer reputation scoring": "Punteggio reputazione sviluppatore",
    "Rexx Network rules enforcement": "Applicazione regole Rete Rexx",
    "Risk threshold evaluation": "Valutazione soglia di rischio",
    "Permission consistency check": "Controllo coerenza permessi",
    "Fast-track (Rexx Network app)": "Corsia rapida (app Rete Rexx)",
  },
};

export const STATUS_TR = {
  en: { VERIFIED: "VERIFIED", NOT_VERIFIED: "NOT VERIFIED", REGULARIZABLE: "REGULARIZABLE" },
  it: { VERIFIED: "VERIFICATA", NOT_VERIFIED: "NON VERIFICATA", REGULARIZABLE: "REGOLARIZZABILE" },
};

export const ERROR_TR = {
  it: {
    "Email already registered": "Email già registrata",
    "Invalid email or password": "Email o password non validi",
    "You cannot request your own app": "Non puoi richiedere la tua stessa app",
    "You already have a pending request for this app": "Hai già una richiesta in attesa per questa app",
    "App not available": "App non disponibile",
    "Not authenticated": "Non autenticato",
    "App not found": "App non trovata",
    "Storage upload failed": "Caricamento nello storage fallito",
  },
};

function resolve(obj, path) {
  return path.split(".").reduce((o, k) => (o == null ? o : o[k]), obj);
}

export function makeT(lang) {
  const dict = translations[lang] || translations.en;
  return (path, vars) => {
    let val = resolve(dict, path);
    if (val == null) val = resolve(translations.en, path);
    if (typeof val === "string" && vars) {
      Object.keys(vars).forEach((k) => { val = val.replace(`{${k}}`, vars[k]); });
    }
    return val == null ? path : val;
  };
}

export function translateCheck(lang, name) {
  return (CHECK_TR[lang] && CHECK_TR[lang][name]) || name;
}
export function translateStatus(lang, status) {
  return (STATUS_TR[lang] && STATUS_TR[lang][status]) || (STATUS_TR.en[status] || status);
}
export function translateError(lang, msg) {
  if (!msg) return msg;
  return (ERROR_TR[lang] && ERROR_TR[lang][msg]) || msg;
}
